export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "DOWNLOAD_FILE_FAILURE";
export const CLEAR_ERROR_DOWNLOAD = "CLEAR_ERROR_DOWNLOAD";
export const CLEAR_SUCCESS_DOWNLOAD = "CLEAR_SUCCESS_DOWNLOAD";
export const CLEAR_ONGOING_DOWNLOAD = "CLEAR_ONGOING_DOWNLOAD";



// WEBPACK FOOTER //
// ./src/utils/downloader/downloaderActionType.js